import React from "react";
import { ChevronDown, ChevronUp } from "lucide-react";
import { cn } from "@/lib/utils";

type ExpandCollapseButtonProps = {
  isExpanded: boolean;
  onClick: () => void;
};

export const ExpandCollapseButton: React.FC<ExpandCollapseButtonProps> = ({ isExpanded, onClick }) => (
  <button
    type="button"
    onClick={onClick}
    className={cn(
      "inline-flex items-center gap-2 rounded-md border px-3 py-1.5 text-sm font-medium transition-all",
      "bg-desert-sand-50 border-desert-sand-200 text-desert-sand-600",
      "hover:border-desert-sand-300 hover:bg-desert-sand-100",
    )}
  >
    {isExpanded ? (
      <>
        <ChevronUp size={16} className="text-desert-sand-500" />
        <span>Collapse all</span>
      </>
    ) : (
      <>
        <ChevronDown size={16} className="text-desert-sand-500" />
        <span>Expand all</span>
      </>
    )}
  </button>
);
